import LOGO from './logo/logo.jpg'
import PROMO from './login/promo.jpg'
import IMAGE_NOT_FOUND from './imageNotFound.jpg'
import carPlan from './carPlan/carPlan.png'
import ENGLISH_FLAG from './flags/gb.png'
import GREEK_FLAG from './flags/gr.png'

const Images = {
	logo: LOGO,
	promo: PROMO,
	imageNotFound: IMAGE_NOT_FOUND,
	carPlan: carPlan,
	englishFlag: ENGLISH_FLAG,
	greekFlag: GREEK_FLAG
}

export default Images